import { SurveyQuestion } from "../models"
import getBranchingRule from "./getBranchingRule"
import getQuestionContent from "./getQuestionContent"

/** Returns the IDs of questions that branch to the question at `key`. */
export const branchedFrom = (key: number, questions: (SurveyQuestion | null)[]) => {
    const questionIDs: string[] = []
    const targetID = getQuestionContent(questions[key])?.questionId
    questions.forEach(question => {
        const branchingRule = getBranchingRule(question as SurveyQuestion)
        if (branchingRule) {
            const { defaultQuestionId, destinationQuestionId } = branchingRule;
            const hasPerChoiceDestination = "destinations" in branchingRule &&
                branchingRule.destinations?.some(destination =>
                    destination !== null && destination.destinationQuestionId === targetID
                );
            if (defaultQuestionId === targetID || destinationQuestionId === targetID || hasPerChoiceDestination) {
                const questionFrom = getQuestionContent(question)?.questionId
                if (questionFrom){
                    questionIDs.push(questionFrom)
                }
            }
        }
    })
    return questionIDs
}